var E = /[\t-\r \x85\u200E\u200F\u2028\u2029]/i;
export {
  E as WHITE_SPACE_REGEX
};
